<template>
    <div class="iapp-container" v-loading="loading">
        <header>
            <div>
                <img src="../assets/logo/logo_iapp@2x.png" alt />
                <span>{{$t('login_signin_ifree')}}</span>
            </div>
            <i class="iconfont icon-cancel" @click="back2Login"></i>
        </header>
        <h2>{{$t('signin')}}</h2>
        <div class="iapp-form">
            <div class="login-user">
                <i class="iconfont icon-user"></i>
                <input v-model="account" type="text" :placeholder="$t('msg_phone')" />
            </div>
            <input type="text" style="display: none;" />
            <input type="password" style="display: none;" />
            <div class="login-user">
                <i class="iconfont icon-password"></i>
                <input v-model="password" type="password" :placeholder="$t('login_password_as')" />
            </div>
            <button @click="login">{{$t('signin')}}</button>
        </div>
    </div>
</template>

<script>
import { thirdPartyLoginGtag } from "@/lib/gtag.js";

export default {
    props: {
        //使用类型
        useType: {
            type: String,
            default: "login"
        }
    },
    data() {
        return {
            loading: false,
            account: "",
            password: "",
            avatar: require("../assets/avatar/default_avartar_boy@2x.png")
        };
    },
    methods: {
        back2Login() {
            this.$emit("close");
        },

        /**
         * 获取iAPP信息
         */
        login() {
            if (!this.account.trim() || !this.password.trim()) {
                this.$msg.error(this.$t("msg_fill"));
                return;
            }
            this.loading = true;
            this.$req
                .post("oauth/getIappInfo", {
                    account: this.account,
                    password: this.password
                })
                .then(({ data }) => {
                    if (data.code === "2000") {
                        //如果是绑定模式下，则传递绑定值
                        if (this.useType === "binding") {
                            this.$emit("login", data.data);
                            return;
                        }
                        this.openLogin(data.data);
                    } else {
                        this.$msg.error(data.msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        /**
         * 快捷登录ebbly
         * @param {*} val iApp用户信息
         */
        openLogin(val) {
            this.$req
                .post("v2_0/thirdPartyLogin", {
                    type_id: 4,
                    openid: val.unionid,
                    avatar: val.avatar || "",
                    nikename: val.nickname || "",
                    email: val.email
                })
                .then(({ data }) => {
                    //埋点
                    thirdPartyLoginGtag({
                        登录类型: "mogo",
                        账户名称: val.nickname,
                        用户ID: data.data.user_id || ""
                    });
                    if (data.code === "2000") {
                        data.data.user_info.nickname =
                            val.nickname || val.mobile || val.email;
                        this.$store.dispatch("updateToken", data.data.token);
                        this.$store.dispatch("updateUser", data.data);
                        this.$store.dispatch("updateAvatar", this.avatar);
                        this.back2Login();
                        this.$store.dispatch("toggleShowLogin", false);
                    } else {
                        this.$msg.error(data.msg);
                    }
                });
        }
    }
};
</script>

<style>
.iapp-container {
    width: 700px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.19), 0 8px 17px rgba(0, 0, 0, 0.2);
}
.iapp-container header {
    height: 40px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
}
.iapp-container header > div {
    display: flex;
    align-items: center;
}
.iapp-container header img {
    height: 20px;
    width: 20px;
    margin-right: 10px;
}
.iapp-container header .iconfont {
    font-size: 20px;
    cursor: pointer;
}
.iapp-container header .iconfont:hover {
    color: #0084ff;
}
.iapp-container h2 {
    color: #0084ff;
    text-align: center;
    font-size: 30px;
    margin-top: 80px;
}
.iapp-form .iconfont {
    position: absolute;
    left: 10px;
    top: 5px;
    font-size: 24px;
    color: #0084ff;
}
.iapp-container .iapp-form {
    width: 400px;
    margin: 0 auto;
}
.iapp-form .login-user {
    position: relative;
    box-sizing: border-box;
    padding-left: 40px;
    border-bottom: 1px solid #e6e6e6;
    margin: 20px 0 0;
}
.login-user input {
    padding: 5px 0;
    width: 100%;
}
.iapp-form > button {
    width: 400px;
    height: 50px;
    margin: 60px 0;
    background-color: #0084ff;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/iapp/Index.vue